import React, { Component } from 'react'
import { MuiGrid, MuiTextField, MuiButton, MuiTypography } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme';
import { WeeklyAvailabilityScheduleUtil } from '../../weeklyAvailability';
import { toast } from 'react-toastify';
import lodashUtil from "lodash";
import RadioButtonComponent from '../teacher/RadioButtonComponent';

export class AddSharedRoomComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      toggleChange: false,
      editFlag: this.props.editFlag,
      isScheduleOpen: this.props.isScheduleOpen,
      isPreferredPeriod: false,
      isChecked: this.props.room.weeklyAvailability.availableForAllHours,
      weeklyAvailabilitySchedule: [
        { id: 1, weekDays: [], outFrom: "", outUntill: "", outFromStr: "", outUntillStr: "" }
      ],
      weeklyAvailability: this.props.room.weeklyAvailability,
      errors: [],
      roomObject: {}
    }
  }


  componentWillMount() {
    if (this.state.weeklyAvailability.availableForAllHours !== "true" && this.state.weeklyAvailability.availableForAllHours !== true) {
      this.state.weeklyAvailability.availableForAllHours = "false"
      this.state.weeklyAvailabilitySchedule = WeeklyAvailabilityScheduleUtil.destructorOfWeeklyAvailabilitySchedule(this.state.weeklyAvailability)
      let weeklyAvailabilityDisplay = WeeklyAvailabilityScheduleUtil.constructWeeklyAvailability(this.state.weeklyAvailabilitySchedule)
      this.state.weeklyAvailability.unAvailableDuration = weeklyAvailabilityDisplay.weeklyAvailabilityList
      this.state.weeklyAvailabilityDisplayList = weeklyAvailabilityDisplay.weeklyAvailabilityDisplayList
    } else {
      this.state.weeklyAvailability.availableForAllHours = "true"
    }

    if (this.props.room != undefined) {
      let roomObject = JSON.parse(JSON.stringify(this.props.room));
      this.setState({
        roomObject: roomObject
      })
    }
  }


  handleOnChange = (name, event) => {
    let roomObject = { ...this.state.roomObject }
    roomObject[name] = event.target.value
    if (name === 'name' && roomObject.name.length >= 2) {
      if (roomObject.name.length <= 4) {
        this.generatingRoomCode(roomObject)
      }
    }

    if (name === 'roomCount' && roomObject.roomCount < 1 && roomObject.roomCount !== "") {
      roomObject.roomCount = 1
    }
    this.setState({
      roomObject: roomObject
    })
    this.props.updateData()
  }

  generatingRoomCode = (roomObject) => {
    let roomCode;
    roomObject.roomCode = roomObject.roomCode.replace(/\s/g, '')
    roomCode = this.checkingRoomIdExists(roomObject);
    roomObject.roomCode = roomCode;
    this.setState({
      roomObject: roomObject
    })
  }

  handleChangeForRoom = (roomCode) => {
    let roomObject = this.state.roomObject
    roomObject.roomCode = roomCode
    this.setState({
      roomObject: roomObject
    })
  }

  checkingRoomIdExists = (roomObject) => {
    let isIdTaken = true;
    let count = 0;
    let roomCode;
    let first3LettersOfName;
    let sharedRoomArray = this.props.roomList;
    first3LettersOfName = roomObject.name.substring(0, 3).toUpperCase();
    roomCode = first3LettersOfName;

    while (isIdTaken === true) {
      let roomCodeExists = lodashUtil.find(sharedRoomArray, ["roomCode", roomCode])
      if (roomCodeExists != undefined) {
        if (roomObject._id != undefined) {
          // if (roomCodeExists.length > 2) {
          if (roomCodeExists.roomCode === roomCode && roomCodeExists._id == roomObject._id) {
            isIdTaken = false;
          } else {
            ++count
            roomCode = (first3LettersOfName + count);
          }
        } else {
          if (roomCodeExists != undefined) {
            if (roomCodeExists.name != roomObject.name) {
              ++count
              roomCode = (first3LettersOfName + count);
            } else {
              isIdTaken = false;
            }
          } else {
            isIdTaken = false;
          }
        }
      } else {
        isIdTaken = false;
      }
    }
    return roomCode;
  }


  handleAdd = async () => {
    let roomObject = { ...this.state.roomObject }
    let error = []
    if (roomObject.roomCount <= 0 || roomObject.roomCount === "" && !roomObject.roomCount.match(/(^[0-9]*$)/)) {
      error["roomCount"] = "Invalid number format"
      roomObject.roomCount = 1
    } else {
      roomObject.weeklyAvailability = this.state.weeklyAvailability
      roomObject.weeklyAvailabilityDisplayList = this.state.weeklyAvailabilityDisplayList
      await this.props.addRow(roomObject)
      this.setState({
        errors: error,
        name: '', roomCount: '', description: ''
      })
    }
  }

  handleEdit = async () => {
    let roomObject = { ...this.state.roomObject }
    let error = []
    if (roomObject.roomCount <= 0 || roomObject.roomCount === "" && !roomObject.roomCount.match(/(^[0-9]*$)/)) {
      error["roomCount"] = "Invalid number format"
    } else {
      roomObject.weeklyAvailability = this.state.weeklyAvailability
      roomObject.weeklyAvailabilityDisplayList = this.state.weeklyAvailabilityDisplayList

      this.props.roomObjectChanged(roomObject, this.props.room);

      await this.props.editRoom(roomObject)
      this.setState({
        errors: error,
        name: '', roomCount: '', description: ''
      })
    }
  }

  onClickOfCancelInRoomAvailabilitySchedule = () => {
    let weeklyAvailabilitySchedule = WeeklyAvailabilityScheduleUtil.destructorOfWeeklyAvailabilitySchedule(this.state.weeklyAvailability)
    if (weeklyAvailabilitySchedule.length > 0) {
      this.setState({
        isScheduleOpen: true,
        weeklyAvailabilitySchedule: weeklyAvailabilitySchedule
      });
    } else {
      this.setState({
        weeklyAvailabilitySchedule: [
          { id: 1, weekDays: [], outFrom: "", outUntill: "", outFromStr: "", outUntillStr: "" }
        ]
      });
    }
    this.setState({
      isScheduleOpen: false,
      isChecked: true
    });
  };


  renderAvailabilityScheduleRow = () => {
    let weeklyAvailabilitySchedule = this.state.weeklyAvailabilitySchedule;
    let initObj = WeeklyAvailabilityScheduleUtil.initWeeklyAvailability();
    weeklyAvailabilitySchedule.push({
      id: weeklyAvailabilitySchedule.length + 1,
      weekDays: [],
      ...initObj
    });
    this.setState({
      weeklyAvailabilitySchedule: weeklyAvailabilitySchedule
    });
    this.props.updateData()
  };


  removeWeeklyAvailabilitySchedule = key => {
    let weeklyAvailabilitySchedule = this.state.weeklyAvailabilitySchedule;
    if (weeklyAvailabilitySchedule.length === 1) {
      this.state.weeklyAvailability["availableForAllHours"] = "true"
      this.state.weeklyAvailability.unAvailableDuration = []
      let initObj = WeeklyAvailabilityScheduleUtil.initWeeklyAvailability();
      this.setState({
        isScheduleOpen: false,
        weeklyAvailabilityDisplayList: undefined,
        weeklyAvailabilitySchedule: [
          { id: 1, weekDays: [], ...initObj }
        ]
      });
    } else {
      weeklyAvailabilitySchedule.splice(key, 1);
      this.setState({ weeklyAvailabilitySchedule: weeklyAvailabilitySchedule })
    };
    this.props.updateData()
  };

  onClickOfSaveInTeacherAvailabilitySchedule = () => {
    let validationFlag = false
    let weeklyAvailabilitySchedule = this.state.weeklyAvailabilitySchedule
    for (let i = 0; i < weeklyAvailabilitySchedule.length; i++) {
      let weeklyAvailabilityScheduleObj = weeklyAvailabilitySchedule[i]
      if (weeklyAvailabilityScheduleObj.weekDays.length === 0) {
        toast('Please select atleast one day')
        validationFlag = true
        break
      }
      if (weeklyAvailabilityScheduleObj.outFrom >= weeklyAvailabilityScheduleObj.outUntill) {
        toast('Outuntill should be after outfrom')
        validationFlag = true
        break
      }
    }

    if (validationFlag == false) {
      this.state.weeklyAvailability["availableForAllHours"] = "false"
      let weeklyAvailabilityDisplay = WeeklyAvailabilityScheduleUtil.constructWeeklyAvailability(this.state.weeklyAvailabilitySchedule)
      this.state.weeklyAvailability.unAvailableDuration = weeklyAvailabilityDisplay.weeklyAvailabilityList
      this.state.weeklyAvailabilityDisplayList = weeklyAvailabilityDisplay.weeklyAvailabilityDisplayList

      this.setState({
        isScheduleOpen: false
      });
    }
    this.props.updateData()
  };
  handleChangeOfRadioButton = event => {
    this.state.weeklyAvailability["availableForAllHours"] = event.target.value;
    if (event.target.value == "true") {
      this.state.weeklyAvailability["unAvailableDuration"] = []
      let weeklyAvailabilitySchedule = []
      this.setState({
        isScheduleOpen: false,
        weeklyAvailabilitySchedule: weeklyAvailabilitySchedule,
        weeklyAvailabilityDisplayList: []
      });
    } else {
      let initObj = WeeklyAvailabilityScheduleUtil.initWeeklyAvailability();
      this.setState({
        isScheduleOpen: true,
        weeklyAvailabilitySchedule: [
          { id: 1, weekDays: [], ...initObj }
        ]
      });
    }
  };
  onClickOfRadioButton = () => {
    this.setState({
      isScheduleOpen: true,
    });
  }
  onClickOfCancelInTeacherAvailabilitySchedule = async () => {
    if (this.state.weeklyAvailabilitySchedule[0].weekDays.length === 0) {
      this.state.weeklyAvailability["availableForAllHours"] = "true"
    }
    else if (this.state.weeklyAvailability.unAvailableDuration == undefined || this.state.weeklyAvailability.unAvailableDuration.length === 0) {
      this.state.weeklyAvailability["availableForAllHours"] = "true"
    }
    if (this.state.weeklyAvailability["availableForAllHours"] === "true") {
      this.state.weeklyAvailability.unAvailableDuration = []
      this.state.weeklyAvailabilitySchedule = [
        { id: 1, weekDays: [] }
      ]
    }
    let weeklyAvailabilitySchedule = await WeeklyAvailabilityScheduleUtil.destructorOfWeeklyAvailabilitySchedule(this.state.weeklyAvailability)
    if (weeklyAvailabilitySchedule !== undefined) {
      let weeklyAvailabilityDisplay = WeeklyAvailabilityScheduleUtil.constructWeeklyAvailability(weeklyAvailabilitySchedule)
      this.state.weeklyAvailability.unAvailableDuration = weeklyAvailabilityDisplay.weeklyAvailabilityList
      this.state.weeklyAvailabilityDisplayList = weeklyAvailabilityDisplay.weeklyAvailabilityDisplayList
    }

    this.setState({
      weeklyAvailabilitySchedule: weeklyAvailabilitySchedule,
      isScheduleOpen: false
    });
  };
  cancelAddNewSharedRoom = () => {
    this.props.cancelAddNewSharedRoom()
    this.props.confirmDialogSharedRoom.isChanged = false
  }
  render() {
    const { i18n } = this.props
    return (
      <MuiGrid container xs={12} style={theme.addSharedRoomGridStyle}>
        <MuiGrid container xs={12} justify='space-between' >
          <MuiGrid container xs={6} style={{ paddingLeft: 10, paddingRight: 10 }} >
            <MuiGrid item xs={12} >
              <MuiTextField
                fullWidth
                id="name"
                variant="outlined"
                margin="normal"
                autoFocus
                required
                label={i18n.sharedRooms.roomName}
                onChange={(event) => this.handleOnChange('name', event)}
                value={this.state.roomObject.name} />

            </MuiGrid>
            <MuiGrid xs={12} align='left'>
              <MuiTypography color="error" variant="caption">
                {this.state.errors.roomName}
              </MuiTypography>
            </MuiGrid>
          </MuiGrid>
          <MuiGrid container xs={3} style={{ paddingRight: 10 }} >
            <MuiGrid item xs={12} >
              <MuiTextField fullWidth
                id="roomCode"
                margin="normal"
                variant="outlined"
                disabled={true}
                style={{ width: "100%", height: "100%" }}
                label={i18n.sharedRooms.roomCode}
                value={this.state.roomObject.roomCode} /></MuiGrid>
          </MuiGrid>
          <MuiGrid container xs={3} style={{ paddingRight: 10 }} >
            <MuiGrid item xs={12} >
              <MuiTextField fullWidth
                id="roomCount"
                margin="normal"
                variant="outlined"
                style={{ width: "100%", height: "100%" }}
                label={i18n.sharedRooms.roomCount}
                type="number"
                onChange={(event) => this.handleOnChange('roomCount', event)}
                value={this.state.roomObject.roomCount} /></MuiGrid>
            <MuiGrid xs={12} align='left'>
              <MuiTypography color="error" variant="caption">
                {this.state.errors.roomCount}
              </MuiTypography>
            </MuiGrid>

          </MuiGrid>
        </MuiGrid>

        <MuiGrid item xs={12} alignItems="left" alignContent="flex-start" style={{ paddingLeft: 10, paddingRight: 10 }}>
          <MuiTextField
            id="description"
            margin="normal"
            fullWidth
            variant="outlined"
            style={{ width: "100%", height: "100%" }}
            label={i18n.sharedRooms.description}
            onChange={(event) => this.handleOnChange('description', event)}
            value={this.state.roomObject.description}
          />
        </MuiGrid>

        <MuiGrid container style={{ paddingLeft: "10px" }}>
          <MuiTypography
            style={theme.radioTitleStyle}>
            {i18n.sharedRooms.avalability}
          </MuiTypography>
          <RadioButtonComponent
            {...this.props}
            {...this.state}
            handleChangeOfRadioButton={this.handleChangeOfRadioButton}
            onClickOfRadioButton={this.onClickOfRadioButton}
            renderAvailabilityScheduleRow={this.renderAvailabilityScheduleRow}
            onClickOfSaveInTeacherAvailabilitySchedule={this.onClickOfSaveInTeacherAvailabilitySchedule}
            onClickOfCancelInTeacherAvailabilitySchedule={this.onClickOfCancelInTeacherAvailabilitySchedule}
            removeWeeklyAvailabilitySchedule={this.removeWeeklyAvailabilitySchedule}
          /></MuiGrid>

        <MuiGrid container xs={12} alignItems="flex-end" justify="flex-end">

          <MuiGrid item style={{ paddingBottom: 10 }}>
            <MuiButton
              disabled={this.state.isScheduleOpen}
              style={this.state.isScheduleOpen ? theme.secondaryButtonDisabledStyle : theme.secondaryButtonStyle}
              onClick={() => this.cancelAddNewSharedRoom()} id='cancel'>Cancel</MuiButton>
          </MuiGrid>
          <MuiGrid item style={{ paddingLeft: 10, paddingRight: 10, paddingBottom: 10 }}>
            <MuiButton
              disabled={this.state.isScheduleOpen || !this.props.confirmDialogSharedRoom.isChanged}
              style={this.state.isScheduleOpen || !this.props.confirmDialogSharedRoom.isChanged ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle}
              onClick={this.state.editFlag ? () => this.handleEdit() : () => this.handleAdd()} id='ok' >{i18n.commonTexts.apply}</MuiButton>
          </MuiGrid>
        </MuiGrid>
      </MuiGrid>
    )
  }
}

export default AddSharedRoomComponent





